import React, { useState, useEffect } from 'react'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import CreatePage from '../../../composents/CreatePage'
import { ApiErrors, ApiGeneric } from '../../../api'

const title = 'Subscriptions'
const headers = {
  icon: 'feather icon-plus',
  title: title,
  description: 'creation of new subscription',
  breadcrumbs: [
    {
      title: title,
      link: '/hydrowallet/subscriptions',
    },
  ],
}

const api = new ApiGeneric()

export default function SellWater() {
  const [loader, setLoader] = useState(false),
    [errors, setErrors] = useState({}),
    [quantity, setQuantity] = useState(0),
    [cost, setCost] = useState(0),
    types = [
      {
        value: 'free',
        label: 'Free',
      },
      {
        value: 'fixed',
        label: 'Fixed',
      },
    ],
    [type, setType] = useState(''),
    [setting, setSetting] = useState({}),
    [clients, setClients] = useState([])

  async function onGet() {
    try {
      const clients = await api.onSend('/clients?limit=all')

      const clientDTO = clients.docs?.map((client) => ({
        value: client.id,
        label: client.name,
      }))
      setClients(clientDTO)
    } catch (e) {
      if (e instanceof ApiErrors) {
      } else {
      }
    }

    try {
      const setting = await api.onSend('/settings?s=HDP')
      setSetting(setting.docs[0])
    } catch (e) {
      if (e instanceof ApiErrors) {
      } else {
      }
    }
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = Object.fromEntries(formData)
    setLoader(true)
    setErrors({})
    let res = await resources.subscription
      .create(object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/hydrowallet/subscriptions')
    } else if (res.status === 422) {
      setErrors(
        res.data.errors.reduce((acc, error) => {
          return { ...acc, [error.field]: error.message }
        }, {})
      )
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  return (
    <CreatePage show_error={errors['not_autorized']} headers={headers}>
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <Field
                  name="HDP"
                  type="number"
                  step="any"
                  className="mb-3"
                  error={errors['HDP']}
                  onChange={(e) => setQuantity(e.target.value)}
                  required
                >
                  HDP
                </Field>

                <Field
                  type="number"
                  value={setting?.value * quantity || 1}
                  step="any"
                  className="mb-3"
                  readOnly
                >
                  Water Quantity(L)
                </Field>

                <Field
                  name="HDPCOST"
                  type="number"
                  step="any"
                  className="mb-3"
                  error={errors['HDPCOST']}
                  onChange={(e) => setCost(e.target.value)}
                  required
                >
                  HDP Cost
                </Field>
                <Field
                  type="number"
                  className="mb-3"
                  step="any"
                  error={errors['cost']}
                  value={cost * quantity}
                  required
                  readOnly
                >
                  Subscription cost
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </CreatePage>
  )
}
